import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Http, Headers } from '@angular/http';
import { Storage } from '@ionic/storage';
import { Events } from '@ionic/angular';
import { Router, NavigationExtras } from '@angular/router';
import { Device } from '@ionic-native/device/ngx';
import { Network } from '@ionic-native/network/ngx';
import { ToastController } from '@ionic/angular';
import * as firebase from 'firebase';

let wpUrl = 'https://lawbyphone2.betaplanets.com/';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class AllServicesService {
  onlineRef:any;

  url = 'https://lawbyphone2.betaplanets.com/wp/v2/';
  totalPosts = null;
  pages: any;

  constructor(public toastController: ToastController, private http: HttpClient, public myHttp:Http, private network: Network, public storage: Storage, public events: Events, private router: Router, private device: Device,) {
  }



  getPosts(page = 1, userToken: any = '', mypost: number = 0, c: number): Observable<any[]> {
    let category_url = c ? ("&service_category=" + c) : "";
    let options = {
      observe: "response" as 'body',
      params: {
        per_page: '10',
        page: '' + page
      }
    };
    let tokenString = '';
    if (userToken != '') {
      tokenString = '&token=' + userToken;
    }

    return this.http.get<any[]>(this.url + 'beacon_services?_embed' + tokenString + "&mypost=" + mypost + category_url, options).pipe(
      map(resp => {
        this.pages = resp['headers'].get('x-wp-totalpages');
        this.totalPosts = resp['headers'].get('x-wp-total');

        let data = resp['body'];

        for (let post of data) {
          post.media_url = post['media_url'];
        }
        return data;
      })
    )
  }

  getProducts(page = 1, userToken: any = '', mypost: number = 0, c: number): Observable<any[]> {
    let category_url = c ? ("&service_category=" + c) : "";
    let options = {
      observe: "response" as 'body',
      params: {
        per_page: '10',
        page: '' + page
      }
    };

    return this.http.get<any[]>(this.url + 'products?_embed&token=' + userToken + "&mypost=" + mypost + category_url, options).pipe(
      map(resp => {
        this.pages = resp['headers'].get('x-wp-totalpages');
        this.totalPosts = resp['headers'].get('x-wp-total');

        let data = resp['body'];

        for (let post of data) {
          post.media_url = post['media_url'];
        }
        return data;
      })
    )
  }



  getPostContent(id) {
    return this.http.get(this.url + 'beacon_services/' + id + '?_embed').pipe(
      map(post => {
        post['media_url'] = post['media_url'];
        return post;
      })
    )
  }

  doRegister(user_data) {
    console.log("SERVICES === ", user_data);
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/register', {
      email: user_data.email,
      password: user_data.password,
      name: user_data.name,
      lastname: user_data.lastname,
      phone: user_data.phone,
      address: user_data.address,
      city: user_data.city,
      state: user_data.state,
      zip: user_data.zip,
      dob: user_data.dob,
      gender: user_data.gender,
      jw_auth_sec: "wivxCNm$<(+WF#7}1]TWMUl7OaU*TxSfhgdfhghdfkgd$^&$&^&*$HFFJKGJjgjf(r*$F8:akLdapjD[j.g0wgra#c/f,P`1l"
    })
  }

  doLogin(email, password) {
    console.log("SERVICE == " + email);
    return this.http.post(wpUrl + 'wp-json/jwt-auth/v1/token', {
      username: email,
      password: password,
      jw_auth_sec: "wivxCNm$<(+WF#7}1]TWMUl7OaU*TxSfhgdfhghdfkgd$^&$&^&*$HFFJKGJjgjf(r*$F8:akLdapjD[j.g0wgra#c/f,P`1l"
    })
  }

  getCategory() {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/fetch_cat', {
      user_login: 1
    }).pipe(
      map(user => {
        return user;
      })
    )

  }

  doReset(user_login) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/retrieve_password', {
      user_login: user_login
    }).pipe(
      map(user => {
        return user;
      })
    )

  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  addProduct(feed, user) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/create_product', {
      post_title: feed.post_title,
      post_content: feed.post_content,
      price: feed.price,
      category: feed.category,
      token: user.token
    }).pipe(
      map(user => {
        return user;
      })
    )
  }

  addContact(feed, user, service) {

    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/create_contact', {
      name: feed.name,
      post_content: feed.post_content,
      email: feed.email,
      contact_number: feed.contact_number,
      service: service,
      token: user.token
    }).pipe(
      map(user => {
        return user;
      })
    )
  }


  getUser(token) {
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/getProfile/?token=' + token).pipe(
      map(user => {
        return user;
      })
    )
  }


  GetPlan() {
    return this.http.get(wpUrl + 'wp-json/pmpro/v1/listofplans').pipe(
      map(plan => {
        return plan;
      })
    )
  }

  GetNearBy(lat,lng) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/getNearBy',{
      type:0,
      lat:lat,
      lng:lng 
    }).pipe(
      map(service => {
        return service;
      })
    )
  }



  SubscribePlan(payDetails) {
    console.table(payDetails);
    let header = new HttpHeaders({ 'Content-Type': 'application/json' });
    header.append('user-id', payDetails.userid);
    header.append('access-token', payDetails.token);
    let options = { headers: header };
    console.log(header.get('user-id'), header.get('access-token'));

    return this.http.post(wpUrl + '/wp-json/pmpro/v1/subscribeuser', {
      //return this.http.post(wpUrl + 'wp-json/pmpro/v1/subscribeuser',{
      planid: payDetails.planid,
      userid: payDetails.userid,
      card_number: payDetails.card_number,
      exp_month: payDetails.exp_month,
      exp_year: payDetails.exp_year,
      cvc: payDetails.cvc
    }, options);

  }

  getMemberLevel(user_id) {
    return this.http.get(wpUrl + 'wp-json/pmpro/v1/getlevelforuser/' + user_id).pipe(
      map(user => {
        return user;
      })
    )
  }

  CancelMembership(user) {
    return this.http.post(wpUrl + 'wp-json/pmpro/v1/cancelsubscription', {
      userid: user
    })
  }

  //wp-json/pmpro/v1/cancelsubscription

  sendData(endPoint,data){
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/'+endPoint,data).pipe(
      map(data => {
        return data;
      })
    )
      
  }

  sendDataFIle(endPoint,data,headers){
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/'+endPoint,data,headers).pipe(
      map(data => {
        return data;
      })
    )
      
  }

  Upload(endPoint,data,headers){
    return this.http.post(endPoint,data,{headers}).pipe(
      map(data => {
        return data;
      })
    )
      
  }

  getCurrentUserInfo(token) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/getCurrentUserInfo', {
      token: token
    })
  }

  getSecoondUserInfo1(token, id) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/getSecoondUserInfo1', {
      token: token,
      id: id,

    })
  }

  updateProfile(user_data,token) {
    console.log("SERVICES === ", user_data);
    return this.http.post(wpUrl + 'wp-json/mobileapi/update_profile', {
      token:token,
      first_name: user_data.first_name,
      last_name: user_data.last_name,
      email: user_data.email,
      phone: user_data.phone,
      dob: user_data.dob,
      gender: user_data.gender,
      address: user_data.address,
      apt_suite: user_data.apt_suite,
      city: user_data.city,
      state: user_data.state,
      zip: user_data.zip,
      qualification: user_data.qualification,
      consultation_fee:user_data.consultation_fee,
      bio: user_data.bio,
      jw_auth_sec: "wivxCNm$<(+WF#7}1]TWMUl7OaU*TxSfhgdfhghdfkgd$^&$&^&*$HFFJKGJjgjf(r*$F8:akLdapjD[j.g0wgra#c/f,P`1l"
    })
  }

  GetHospitals(address,lat,lng) {
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/getHospitals/?address='+address+'&lat='+lat+'&lng='+lng).pipe(
      map(h => {
        return h;
      })
    )
  }

  GetConnectedHospitals(user_id) {
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/GetConnectedHospitals/?user_id='+user_id).pipe(
      map(h => {
        return h;
      })
    )
  }

  

  GetMyAppointments(user_id, page) {
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/GetMyAppointments/?user_id='+user_id+'&page='+page).pipe(
      map(a => {
        return a;
      })
    )
  }

  CancelAppointment(user_id, appointment_id) {
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/CancelAppointment/?user_id='+user_id+'&appointment_id='+appointment_id).pipe(
      map(a => {
        return a;
      })
    )
  }

  GetDoctors(hospital_id){
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/GetDoctors/?hospital_id='+hospital_id).pipe(
      map(d => {
        return d;
      })
    )
  }  

  GetFAQs(){
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/get_faqs').pipe(
      map(d => {
        return d;
      })
    )
  } 

  GetPP(){
    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/get_privacy_policy').pipe(
      map(d => {
        return d;
      })
    )
  } 

  getAllDates(hospital_id,doctor_id,selectedDate,endData,todayD){

    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/GetDates/?hospital_id='+hospital_id+'&doctor_id='+doctor_id+'&selectedDate='+selectedDate+'&endData='+endData+'&todayD='+todayD).pipe(
      map(d => {
        return d;
      })
    )
  }

  
  getAllApp(user_id,selectedDate,endData,todayD){

    return this.http.get(wpUrl + 'wp-json/mobileapi/v1/GetDatesApp/?doctor_id='+user_id+'&selectedDate='+selectedDate+'&endData='+endData+'&todayD='+todayD).pipe(
      map(d => {
        return d;
      })
    )
  }

  PayMode(user_id,appointment_id,consultation_fee,type) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/pay_option', {
      user_id: user_id,
      appointment_id: appointment_id,
      consultation_fee: consultation_fee,
      type: type,
    })
  }

  updateToken(userId, deviceID, deviceData, status) {
   return this.http.post(wpUrl + "wp-json/mobileapi/v1/updateDeviceToken", {
       userid: userId,
       deviceID: deviceID,
       deviceData: deviceData,
       status: status
   });
  }

  updateUserSession(user_id, deviceData, myCallId) {
    console.log("SERVICES === ", user_id);
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/update_session_id', {
      user_id:user_id,
      deviceData: deviceData,
      myCallId: myCallId
    })
  }

  // Gravity Forms

  getReportForms(hospital_id,loggedinUserId) {
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/getReportForms", {
      hospital_id: hospital_id,
      patient_id: loggedinUserId
    }).pipe(map(res => {
      return res;
    }));
  }

  getReportDiaryForms(hospital_id,loggedinUserId) {
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/getReportFormsDiary", {
      hospital_id: hospital_id,
      patient_id: loggedinUserId
    }).pipe(map(res => {
      return res;
    }));
  }

  getFilledReportForms(hospital_id,loggedinUserId) {
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/getFilledReportForms", {
      hospital_id: hospital_id,
      patient_id: loggedinUserId
    }).pipe(map(res => {
      return res;
    }));
  }


  getUploadedDocs(hospital_id,loggedinUserId) {
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/getUploadedDocs", {
      hospital_id: hospital_id,
      patient_id: loggedinUserId
    }).pipe(map(res => {
      return res;
    }));
  }


  

  

  getGravityform(userToken, formID) {
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/getGravityform", {
      token: userToken,
        formID: formID
    }).pipe(map(res => {
      return res;
    }));
  }

  createContact(formId,formdata,customData,user_token) {
    // let header = new HttpHeaders({ 'Content-Type': 'application/json' });

    // header.append('access-token', user_token);

    let header: Headers = new Headers();

    let options = { headers: header };
    
    let alldata = {
      input_values:formdata
    };
    var myJSON = JSON.stringify(alldata);

    return this.myHttp.post(wpUrl+"gravityformsapi/forms/"+formId+"/submissions/?userID="+customData.token,myJSON,options).pipe(map(res => {
      return res;
    }));
  }

  getNoti(user_id, page_no){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/get_my_notifications",{
      user_id: user_id,
      page: page_no
    })
  }

  getNotCount(user_id){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/get_my_not_count",{
      user_id: user_id,
    })
  }

  notisopened(user_id){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/notisopened",{
      user_id: user_id
    })
  }

  deleteNoti(nid){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/deleteNoti",{
      nid: nid
    })
  }
  
  submitForm(formId,formdata,user_id,user_token,type){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/submitForm",{
      formId: formId,
      formdata: formdata,
      user_id: user_id,
      user_token: user_token,
      type:type
    })
  }
  
  getUserCurrentSession(user_id){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/getUserCurrentSession",{
      user_id: user_id
    })
  }

  // getCallerInfo(session_id) {
  //   return this.http.get(wpUrl + 'wp-json/mobileapi/v1/getCallerInfo/?session_id=' + session_id).pipe(
  //     map(data => {
  //       return data;
  //     })
  //   )
  // }

  getCallerInfo(session_id) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/getCallerInfo', {
      session_id:session_id
    })
  }

  rateDoctor(appointment_id, rating) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/rateDoctor', {
      appointment_id:appointment_id,
      rating: rating
    })
  }

  sendMissedVideoNotification(caller_id,callie_id) {
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/sendMissedVideoNotification', {
      caller_id: caller_id,
      callie_id: callie_id
    })
  }

  checkNetworkConnection() {
    return this.network.type;
   }

  //

  checkingProcess(){
    let device_uuid = this.device.uuid;
    this.storage.get('user').then(val=>{
      if(val){
        this.checkUser(val.user_id, device_uuid) 
          .subscribe(res2 => {
            let r:any = [];
            r = res2;
            console.log('r: ', r);
            if(r.exist=='1'){
              console.log('exist');
            }
            else{
              console.log('not exist');
              this.logOut();
            }
          }) 
      }
    });
  }

  checkUser(user_id, device_uuid){
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/check_user',{
      user_id: user_id,
      device_uuid: device_uuid
    })
  }

  sendAlert(hospital_id){
    return this.http.post(wpUrl + 'wp-json/mobileapi/v1/stripe_key_reminder',{
      hospital_id: hospital_id
    })
  }

  

  logOut(){ 
    this.storage.get('user').then(val=>{
      if(val){
        let callRef = firebase.database().ref('call/'+val.user_id);
        if(callRef){
          callRef.off();
        }
      }
    });

    setTimeout(() => {
      this.storage.clear();
      this.storage.remove('user');
      this.events.publish('userCheck:created', 'userNotLogin'); 
      this.router.navigate(['/login']);
    }, 800);
    
  }

  //

  createSession(){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/create_session",{
    })
  }

  endSession(session_id){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/end_session",{
      session_id: session_id
    })
  }

  startArc(session_id, appointment_id,user_id,to_user_id){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/start_arc",{
      session_id: session_id,
      appointment_id: appointment_id,
      doctor_id: user_id,
      patient_id: to_user_id,
    })
  }

  endArc(archive_id){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/end_arc",{
      archive_id: archive_id
    })
  }

  getTextData(appointment_id){
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/getTextData",{
      appointment_id: appointment_id
    })
  }


  CheckUserMembership(user_id) {

    // this.checkUser(val.user_id, device_uuid) 
    //       .subscribe(res2 => {
    //         let r:any = [];
    //         r = res2;
    //         console.log('r: ', r);
    //         if(r.exist=='1'){
    //           console.log('exist');
    //         }
    //         else{
    //           console.log('not exist');
    //           this.logOut();
    //         }
    //       }) 


    this.getMemberLevel(user_id).subscribe(res => {
      let plan:any = [];
      plan = res;
      console.log("plan:", plan);
      if(plan.membership && plan.membership.id){
        return true;
      }
      else{
        return false;
      }
    },(err)=>{
      return false;
    });
  }


  CheckMembership() {
    this.storage.get('user').then(val=>{
      if(val && val.role=='doctor'){
        if(val && val.hospital_id){
          this.getMemberLevel(val.hospital_id).subscribe(res => {
            let plan:any = [];
            plan = res;
            console.log(plan);
            console.log(plan.membership);
            if(plan.membership.id){
                  
            }
            else{
              this.logOut();
              this.presentToast("You cannot login in the app as you has not subscribed any membership plan.");
            }
          },(err)=>{
            this.logOut();
            this.presentToast("You cannot login in the app as you has not subscribed any membership plan.");
          });
        }
      }
      
    });

    
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      animated: true,
      cssClass: "my-toast-red",
      duration: 4000
    });
    toast.present();
  }

  getGravityformFilledData(form_id, entry_id) {
    return this.http.post(wpUrl + "wp-json/mobileapi/v1/get_filled_garvity_form_fields", {
      form_id: form_id,
      entry_id: entry_id
    }).pipe(map(res => {
      return res;
    }));
  }
  //

}
